import React from 'react';
import { PolicyData, withPolicyContext } from '../../context/policy';
import { getPolicyStatus } from '../../util/util';
import { BodyContainer, LayoutContainer, TopContainer } from '../common';
import LargeCenterSpinner from '../LargeCenterSpinner';
import AcceptedPolicyActions from '../policy/Actions/AcceptedPolicyActions';
import DraftPolicyQuoteActions from '../policy/Actions/DraftPolicyQuoteActions';
import PolicyActions from '../policy/Actions/PolicyActions';
import Breadcrumbs from '../policy/Breadcrumbs';
import PolicyOverview from '../policy/PolicyOverview';
import { getCurrentGraceLapse } from '../search/util';

interface Props {
	children?: JSX.Element | JSX.Element[];
	policyData: PolicyData;
}

// Handles non-quote policies and issued policies
const PolicyLayout = (props: Props) => {
	const [loading, setLoading] = React.useState<boolean>(false);
	const { graceLapse, policy } = props.policyData;
	props.policyData.setLoading = setLoading;
	const state = getPolicyStatus(policy, getCurrentGraceLapse(graceLapse));

	const renderActions = () => {
		if (props.policyData.policy.issuedTimestamp) {
			return <PolicyActions />;
		} else if (state === 'Accepted') {
			return <AcceptedPolicyActions />;
		} else {
			return <DraftPolicyQuoteActions />;
		}
	};

	return (
		<>
			{loading ? <LargeCenterSpinner /> : null}
			<TopContainer>
				<Breadcrumbs />
				{renderActions()}
			</TopContainer>
			<LayoutContainer>
				<BodyContainer>
					<PolicyOverview />
					{props.children}
				</BodyContainer>
			</LayoutContainer>
		</>
	);
};

export default withPolicyContext<Props>(PolicyLayout);
